<script setup lang="ts">
import type { LinkBreadcrumbItem } from '@shared/ui/menus'

import { AppRoute } from '@shared/config'
import { NavigationBreadcrumbs } from '@shared/ui/menus'

defineOptions({
  name: 'HeaderSettings',
})

const config = computed<LinkBreadcrumbItem[]>(() => [
  {
    id: 'settings',
    text: 'Settings',
    to: AppRoute.Settings,
    disabled: true,
  },
])
</script>

<template>
  <NavigationBreadcrumbs :config="config" />
</template>
